import React, { ReactElement, memo } from "react";
import PageLayout from "../../PageLayout";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CardPromptType } from "../../../store/cardPrompt/types";
import { saveRequest } from "../../../store/cardType/actions";
import { ApplicationState } from "../../../store";
import { Formik } from "formik";
import { useHistory, useParams } from "react-router-dom";
import schema from "./CardType.schema";
import pageStyles from "../../pageStyles";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import TextInput from "../../../common/formElements/TextInput";
import { useToastMessage } from "../../../effects/useToastMessage";
import { toast } from "react-toastify";
import { getById } from "../../../store/cardType/queries";
import { Data } from "../../../store/cardType/types";
import SelectDropDown from "../../../common/formElements/SelectDropDown";
import { User } from "../../../store/user/types";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

const categories = ["Schemes", "Fuel", "Transit", "Alternative", "Loyalty", "Other", "GiftCard"]

const CardPromptEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;
  const title = mode === UPDATE ? "Edit Card Type" : "Add Card Type";
  const cardType = useSelector(id ? getById(id) : () => null);

  const onCancel = () => {
    history.push("/cardType");
  };
  const onSubmit = (values) => {
    const callback = (err: string | null, data: User | null) => {
      if (err) {
        console.log(err);
        let errText = `An error occurred while saving: ${err}`;
        toast.error(errText, {
          closeOnClick: true,
        });
      } else {
        if (mode === CREATE) {
          history.goBack();
        } else {
          toast.success("Saved successfully!", {
            closeOnClick: true,
          });
        }
      }
    };
    dispatch(
      saveRequest({ id: values.id, data: values, }, callback)
    )
  };

  return (
    <PageLayout heading={title}>
      <Formik
        initialValues={cardType || {}}
        validationSchema={schema}
        onSubmit={onSubmit}
        onReset={onCancel}
      >
        {(formikProps) => {
          const { isSubmitting, errors } = formikProps;
          // Show toast errors
          useToastMessage(isSubmitting, errors);
          return (
            <form
              onSubmit={formikProps.handleSubmit}
              onReset={formikProps.handleReset}
              className={classes.formWrapper as string}
            >
              <SectionWrapper title="Card Type">
                <SectionWrapper isChild title="Product label">
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="type" label="Card Type" disabled={mode === UPDATE} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextInput fieldname="ProductID" label="Product ID" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <SelectDropDown
                        label="Product Category"
                        fieldname="ProductCategory"
                        options={categories}
                      />
                    </Grid>
                  </Grid>
                </SectionWrapper>
              </SectionWrapper>

              <FormSubmitButtons />
            </form>
          );
        }}
      </Formik>
    </PageLayout>
  );
};

export default memo(CardPromptEdit);
